import { FlowExtractPtBr } from "./flow-extract-pt-br";

export const FLOW_EXTRACT_EN_US: FlowExtractPtBr = {
	table: {
		description: "Description",
		initialValue: "Opening Balance:",
		finalValue: "Closing Balance:",
		in: "Total of Income:",
		out: "Total of Expenses:",
		value: "Value",
		item: {
			liquidationDate: "SETTLEMENT DATE",
			referenceDate: "REFERENCE DATE",
			type: "TYPE",
			originDestination: "ORIGIN/DESTINATION",
			category: "CATEGORY",
			observation: "OBSERVATION",
			value: "AMOUNT",
		},
	},
	excel: {
		title: "Extract report",
		grouped: {
			day: "by day",
			month: "by month",
			type: "by type",
			category: "by category",
		},
	},
	search: "Search by...",
	yesterday: "Yesterday",
	today: "Today",
	filter: {
		perType: "By Type",
	},
	accountRequired: "An account is required.",
	anticipated: "Anticipated",
	normalValue: "Normal Value",
	anticipatedValue: "Anticipated Value",
};
